export default "__VITE_ASSET__CgEFJ2u8__"